<template>
  <p class="vf-mb-2">Question {{ surveyState?.surveyStep }} of 5</p>
  <div class="vf-flex vf-flex-row vf-gap-x-2">
    <div
      class="vf-h-[5px] vf-w-[40px] vf-rounded-lg vf-bg-blue-700 vf-cursor-pointer"
    ></div>
    <div
      :class="`vf-h-[5px] vf-w-[40px] vf-rounded-lg ${
        surveyState?.surveyStep >= 2 ? 'vf-bg-blue-700' : 'vf-bg-gray-300'
      } vf-cursor-pointer`"
    ></div>
    <div
      :class="`vf-h-[5px] vf-w-[40px] vf-rounded-lg ${
        surveyState?.surveyStep >= 3 ? 'vf-bg-blue-700' : 'vf-bg-gray-300'
      } vf-cursor-pointer`"
    ></div>
    <div
      :class="`vf-h-[5px] vf-w-[40px] vf-rounded-lg ${
        surveyState?.surveyStep >= 4 ? 'vf-bg-blue-700' : 'vf-bg-gray-300'
      } vf-cursor-pointer`"
    ></div>
    <div
      :class="`vf-h-[5px] vf-w-[40px] vf-rounded-lg ${
        surveyState?.surveyStep >= 5 ? 'vf-bg-blue-700' : 'vf-bg-gray-300'
      } vf-cursor-pointer`"
    ></div>
  </div>
</template>

<script setup>
import { useQueryClient } from "@tanstack/vue-query";
import { onMounted, onUnmounted, ref } from "vue";

const queryClient = useQueryClient();
const surveyState = ref(queryClient.getQueryData(["QUERY_SURVEY_STATE"]));

let unsubscribe;
onMounted(() => {
  unsubscribe = queryClient.getQueryCache().subscribe(() => {
    surveyState.value = queryClient.getQueryData(["QUERY_SURVEY_STATE"]);
  });
});

onUnmounted(() => {
  unsubscribe?.();
});
</script>
